// @ts-nocheck

import * as Types from '../../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type CreateNewObjectMutationVariables = Types.Exact<{
  customObjectDefinition?: Types.InputMaybe<Types.CustomObjectDefinitionCreationModelInput>;
}>;

export type CreateNewObjectMutation = { createCustomObjectDefinition: { uid: string } };

export const CreateNewObjectDocument = gql`
    mutation CreateNewObject($customObjectDefinition: CustomObjectDefinitionCreationModelInput) {
  createCustomObjectDefinition(customObjectDefinition: $customObjectDefinition) {
    uid
  }
}
    ` as unknown as DocumentNode<CreateNewObjectMutation, CreateNewObjectMutationVariables>;
